<template>
  <div>
    <div class="row justify-content-center">
      <div class="form-group col-4">
        <label for>Password</label>
        <fg-input
          type="password"
          name="password"
          placeholder="Password"
          v-model="model.password"
          v-validate="modelValidations.password"
          :error="getError('password')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Blood Group</label>
        <el-select
          name="blood"
          class="select-default"
          placeholder="Pick a Blood Group"
          v-model="model.blood_group"
        >
          <el-option
            v-for="option in blood_groups"
            class="select-default"
            :value="option"
            :label="option"
            :key="option"
          ></el-option>
        </el-select>
      </div>

      <div class="form-group col-4">
        <label for>Ref Name</label>
        <fg-input
          type="text"
          name="ref_name"
          placeholder="Ref Name"
          v-model="model.ref_name"
          v-validate="modelValidations.ref_name"
          :error="getError('ref_name')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Ref Address</label>
        <fg-input
          type="text"
          name="ref_address"
          placeholder="Ref Address"
          v-model="model.ref_address"
          v-validate="modelValidations.ref_address"
          :error="getError('ref_address')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Date Joined</label>
        <el-date-picker
          name="doj"
          v-model="model.doj"
          type="date"
          placeholder="Pick a Date"
          v-validate="modelValidations.doj"
        ></el-date-picker>
      </div>

      <div class="form-group col-4">
        <label for>Languages</label>
        <el-select
          v-model="model.languages"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="Choose tags for your article"
        >
          <el-option
            v-for="item in local.languages"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="form-group col-4">
        <label for>Designation</label>
        <el-select
          name="designation"
          v-validate="modelValidations.designation"
          placeholder="Pick a Designation"
          v-model="model.role"
        >
          <el-option
            v-for="option in local.designations"
            class="select-default"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </div>

      <div class="form-group col-4">
        <label for>Bio</label>
        <fg-input
          type="text"
          name="bio"
          placeholder="Bio"
          v-model="model.bio"
          v-validate="modelValidations.bio"
          :error="getError('bio')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Education</label>
        <fg-input
          type="text"
          name="education_level"
          placeholder="Education"
          v-model="model.education_level"
          v-validate="modelValidations.education_level"
          :error="getError('education_level')"
        ></fg-input>
      </div>
    </div>
  </div>
</template>
<script>
import { Upload, DatePicker, Select, Option } from "element-ui";
import { mapGetters } from "vuex";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Upload.name]: Upload,
    [Select.name]: Select,
    [Option.name]: Option
  },
  computed: {
    ...mapGetters({
      blood_groups: "getBloodGroups"
    })
  },
  data() {
    return {
      local: {
        languages: [
          { value: "English", label: "English" },
          { value: "Hindi", label: "Hindi" },
          { value: "Kannada", label: "Kannada" },
          { value: "Tamil", label: "Tamil" },
          { value: "Malayalam", label: "Malayalam" }
        ],
        designations: [
          { value: "doctor", label: "Doctor" },
        ]
      },
      model: {
        blood_group: "",
        ref_name: "",
        ref_address: "",
        doj: "",
        designation: "doctor",
        bio: "",
        education_level: "",
        password: "",
        role: "",
        languages: ""
      },
      modelValidations: {
        blood_group: {
          required: true
        },
        ref_name: {
          required: true
        },
        ref_address: {
          required: true
        },
        doj: {
          required: true
        },
        designation: {
          required: true
        },
        education_level: {
          required: true
        },
        password: {
          required: true,
          min: 6
        }
      }
    };
  },
  methods: {
    handlePreview(file) {
      this.model.imageUrl = URL.createObjectURL(file.raw);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    }
  }
};
</script>
<style lang="scss">
.card-wizard .picture-container .picture {
  input[type="file"] {
    display: none;
  }
}
</style>
